import styled from "styled-components";

export const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

interface RectProps {
  color: string;
}

export const ViewerWrapper = styled.div`
  background-color: #eef3fb;
  max-width: 820px;
  width: fit-content;
  height: 100%;
`;

export const ContainerSvg = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;  
`;
export const DocumentWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  justify-content: center;
`;
export const LoadingText = styled.h2`
  color: #2c2c2c;
`;

export const Wrapper = styled.svg<{ numPages: number }>`
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #aaa;
  @media (max-width: 374px) {
    width: 284px;
    height: ${({ numPages }) => numPages * 401.7225806451613 + (numPages + 2) * 4}px;
  }
  @media (min-width: 375px) and (max-width: 425px) {
    width: 330px;
    height: ${({ numPages }) => numPages * 466.7903225806452 + (numPages + 2) * 4}px;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 384px;
    height: ${({ numPages }) => numPages * 542.91 + (numPages + 2) * 4}px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 688px;
    height: ${({ numPages }) => numPages * 973.1870967741935 + (numPages + 2) * 4}px;
  }
  @media (min-width: 1025px) {
    width: 960px;
    height: ${({ numPages }) => numPages * 1357 + (numPages + 2) * 4}px;
  }
`;

export const Rect = styled.rect<RectProps>`
  fill: ${({ color }) => color};
  opacity: 0.3;
  z-index: 99999;
`;
export const Container = styled.div<{ isDrag: boolean }>`
  overflow: ${({ isDrag }) => (isDrag ? "hidden" : "auto")};
  height: calc(100vh - 140px);
  width: 100%;
  background-color: #aaa;
  position: relative;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 800px) {
    height: calc(100vh - 155px);
  }
`;
export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
  background: #f4f6f8;
  width: 100%;
  height: 40px;
  box-shadow: 0px 1px 2px #2c2c2c;
  padding: 10px;
`;
export const TopWrapperSpan = styled.span`
  display: flex;
  gap: 5px;
  font-size: 1rem;
  font-weight: normal;
  color: #2c2c2c;
  @media (max-width: 768px) {
    flex-direction: column;
    gap:1px;
    font-size: 0.8rem;
  }
`;
export const TopWrapperP = styled.p`
  font-size: 1rem;
  font-family: "Archivo-Bold";
  color: #2c2c2c;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;